import Class from './c-date-picker-body';
import './c-date-picker-body@';

export default Class;